import { CreditProductsApi } from '~/api';
import { action, observable, persist } from '~/modules';

const emptyProductDetails = {
  name: '',
  type: '',
  status: null,
  cardNumber: '',
  bestDayToBuy: '',
  totalLimit: 0,
  usedLimit: 0,
  availableLimit: 0,
  paymentType: null,
};

export default class CreditProductsStore {
  @observable
  productLoanDetails: CreditProductsDetails = emptyProductDetails;

  @observable
  requestedCreditSimulationValue = 0;

  @observable
  simulationPlans: SimulationPlans[] = [];

  @persist('object')
  @observable
  currentSimulationPlan: SimulationPlans | null = null;

  @action
  setRequestedCreditSimulationValue = (value: number) => {
    this.requestedCreditSimulationValue = value;
  };

  @action
  setSimulationPlans = (plans: SimulationPlans[]) => {
    this.simulationPlans = plans;
  };

  @action
  setCurrentSimulationPlan = (plan: SimulationPlans) => {
    this.currentSimulationPlan = plan;
  };

  @action
  setProductLoanDetails = (details: CreditProductsDetails) => {
    this.productLoanDetails = details;
  };

  @action
  getProductLoanDetails = async (id: string) => {
    const data = await CreditProductsApi.getProductsDetails(id);
    this.setProductLoanDetails(data);
  };

  @action
  getSimulationPlans = async (amount: number) => {
    const id = 'this.loanInfo.id'; // TODO: Where this ID should come from?
    const data = await CreditProductsApi.getSimulationPlans(amount, id);
    this.setRequestedCreditSimulationValue(data.requestedAmount);
    this.setSimulationPlans(data.plans);
    // const response = await api.get(`/simulation-plans?amount=${amount}`);
  };
}
